<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2024-09-29 17:02:47
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-12-12 18:16:39
 * @Description:
 * @FilePath: \haozhang_pro\src\pages\physical_report\physical_report.vue
-->
<template>
  <div class='public-content-new physical_report__wrapper' id="tab__content__wrapper_id" v-loading = "requestLoading" :style="{ width: isMin?'100%':'1400px' }">
    <div class="score__view">
      <!-- left -->
      <div class="score__view__left">
        <!-- score -->

        <div v-if = "isLoading" style="position: relative;">
          <img src="/static/ani/report_loading.gif" alt="" width="130px">
          <div class="score__view__left__loading">
            <div class="score__view__left__loading__text">
              <span style="font-size: 26px;" >{{  loadingText }}</span> <span style="font-size: 20px;" >%</span>
            </div>
          </div>
        </div>
        <div v-else-if = "!isOnceCheck && !isLoading">
          <img src="/static/img/physical_report/noCheck.png" alt="" width="130px">
        </div>
        <div class="left__circle__outside" v-else-if = "isOnceCheck && !isLoading" :class="{ 'left__circle__health': checkInfo.score>=90, 'left__circle__risk': checkInfo.score <60, 'left__circle__middle': checkInfo.score >=60 && checkInfo.score <90 }">
          <div class="left__circle__center" >
            <div class="left__circle__inside">
              <div class="left__circle__inside__score"  :class="{ 'healthColor': checkInfo.score>=90, 'riskColor': checkInfo.score <60, 'middleColor': checkInfo.score >=60 && checkInfo.score <90 }">
                <!-- <span>{{ checkInfo.score}}</span> <span class="left__circle__inside__score__unit">分</span>  -->
              </div>
            </div>
          </div>
        </div>
        <!-- center -->
        <div class="score__view__left__center">
          <div class="score__view__left__center__top" :style="{ color:getBannerStyle.color }" v-html = "getBannerStyle.text"></div>
          <div class="score__view__left__center__bottom">{{ this.checkInfo.checkTime&&!isLoading ? `检测完成！最新检测时间：${ this.checkInfo.checkTime }`:"一键检测，财税指标，规避风险" }}</div>
        </div>
      </div>
      <!-- right -->
      <div class="score__view__right">
        <accounting-period ref="physical_report__accountingPeriod" @defaultTime='defaultTime' superStyles="160px" :disabled = "isLoading"
          :isDaterange='false'></accounting-period>
        <el-button type="primary" size="small" style="margin-left: 10px;" @click="onPhysicalReport('2')">{{
          isOnceCheck ? "再次检测" : "立即检测" }}</el-button>
        <el-button type="default" size="small" v-if="physicalInfo">导出</el-button>
      </div>
    </div>
    <!-- tab bar -->
    <div class="report_tab">
      <el-radio-group v-model="tabPosition"  @change="handleTabChange">
        <el-radio-button label="1">记账完整性</el-radio-button>
        <el-radio-button label="2">税务指标检测</el-radio-button>
        <el-radio-button label="3">财务指标检测</el-radio-button>
        <el-radio-button label="4">经营指标分析</el-radio-button>
        <el-radio-button label="5">重要节点提示</el-radio-button>
      </el-radio-group>
    </div>
    <div class="tab__content__wrapper" >
      <!-- tab content 记账完整性 -->
      <div class="tab__content" id="tab__content__1">
        <div class="tab__content__title">
          <div class="tab__content__title__pane">
            <img src="/static/img/physical_report/list_1.png" alt="">
          </div>
          <div class="tab__content__title__text">记账完整性</div>
        </div>
        <div class="tab__content__body">
          <div v-for="item in accountIntegrity" :key="item.key">
            <div class="tab__content__body__item"  :ref = "item.key" :class="{ tab__content__body__tail: accountIntegrity.length - 1 === accountIntegrity.indexOf(item)}">
              <div class="tab__content__body__item__title">
                <span>{{ item.name }}</span>
                <el-popover placement="right" width="1100" trigger="hover" v-if = "Array.isArray(resultInfo[item.key].data)" :close-delay="0" transition="no-fade-in-linear">
                  <public-table :table='tableInfo[item.key]'></public-table>
                  <div class="report__item__icon" slot="reference">
                    <span>计算公式</span>
                  </div>
                </el-popover>
              </div>
              <i class="el-icon-loading" v-if = "resultInfo[item.key].isLoading"></i>
              <div class="tab__content__body__item__result" v-else :class="resultInfo[item.key].result?'c_6': 'riskColor'" >
                {{  resultInfo[item.key].hint  }}
                <span v-if = "!resultInfo[item.key].result && !isLoading && resultInfo[item.key].hint && item.path" class="acc_link ml10" @click = "onJumpPage(item.path,item.query,item)">查看</span>
              </div>
            </div>
            <!-- 子项 -->
            <div class="tab__content__body__item__children" v-if = "item.children && item.children.length">
              <div class="children__item" v-for="c_item in item.children" :key="c_item.key">
                <div class="children__item__title">
                  <div class="children__item__title__text">{{ c_item.name }}</div>
                  <el-popover placement="right" width="640" trigger="hover" v-if = "Array.isArray(resultInfo[c_item.key].data)" :close-delay="0" transition="no-fade-in-linear">
                    <public-table :table='tableInfo[c_item.key]'></public-table>
                    <div class="report__item__icon" slot="reference">
                      <span>计算公式</span>
                    </div>
                  </el-popover>
                </div>
                <i class="el-icon-loading" v-if="resultInfo[c_item.key].isLoading"></i>
                <div class="children__item__result" v-else  :class="resultInfo[c_item.key].result?'c_6': 'riskColor'">
                  {{ resultInfo[c_item.key].hint }}
                  <span v-if = "!resultInfo[c_item.key].result&& !isLoading && resultInfo[c_item.key].hint" class="acc_link ml10" @click = "onJumpPage(c_item.path,c_item.query)">查看</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 税务指标检测 -->
      <div class="tab__content" id="tab__content__2">
        <div class="tab__content__title">
          <div class="tab__content__title__pane"><img src="/static/img/physical_report/list_2.png" alt=""></div>
          <div class="tab__content__title__text">税务指标检测</div>
        </div>
        <div class="tab__content__body">
          <div v-for="item in taxIndex" :key="item.key">
            <div class="tab__content__body__item"  :ref = "item.key">
              <div class="tab__content__body__item__title">
                <span>{{ item.name }}</span>
              </div>
              <i class="el-icon-loading" v-if = "resultInfo[item.key].isLoading"></i>
              <div class="tab__content__body__item__result" v-else :class="resultInfo[item.key].result?'c_6': 'riskColor'" >
                {{  resultInfo[item.key].hint  }}
                <span v-if = "!resultInfo[item.key].result && !isLoading && resultInfo[item.key].hint" class="acc_link ml10" @click = "onJumpPage(item.path,item.query,item)">查看</span>
              </div>
            </div>
            <!-- 子项 -->
            <div class="tab__content__body__item__children" v-if = "item.children && item.children.length">
              <div class="children__item" v-for="c_item in item.children" :key="c_item.key" :class="{ mb20: item.children.length - 1 === item.children.indexOf(c_item)}">
                <div class="children__item__title">
                  <div class="children__item__title__text">{{ c_item.name }}</div>
                </div>
                <i class="el-icon-loading" v-if="resultInfo[c_item.key].isLoading"></i>
                <div class="children__item__result" v-else  :class="resultInfo[c_item.key].result?'c_6': 'riskColor'">
                  {{ resultInfo[c_item.key].hint }}
                  <span v-if = "!resultInfo[c_item.key].result&& !isLoading && resultInfo[c_item.key].hint" class="acc_link ml10" @click = "onJumpPage(c_item.path,c_item.query,c_item)">查看</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 财务指标检测 -->
      <div class="tab__content" id="tab__content__3">
        <div class="tab__content__title">
          <div class="tab__content__title__pane"><img src="/static/img/physical_report/list_3.png" alt=""></div>
          <div class="tab__content__title__text">财务指标检测</div>
          <div class="operation__title acc_link" @click = "handleFinancialExpandAll" v-show = "isOnceCheck">
            <div class="operation__title__wrapper">
              <span>{{ isFinancialExpand?'全部收起':'全部展开' }}</span>
              <img src="/static/icon/public/right_a.png" alt="" :style="{ transform: `rotate(${isFinancialExpand?90:0}deg)` }">
            </div>
          </div>
        </div>
        <div class="tab__content__body">
          <div v-for="item in financialIndex" :key="item.key">
            <div class="tab__content__body__item"  :ref = "item.key" :class="{ tab__content__body__tail: financialIndex.length - 1 === financialIndex.indexOf(item)}">
              <div class="tab__content__body__item__title">
                <img :src="resultInfo[item.key].isExpand?'/static/icon/public/bottom.png':'/static/icon/public/right.png'" alt="" @click="handleExpand(item.key)" v-if = "Array.isArray(resultInfo[item.key].data)">
                <span>{{ item.name }}</span>
              </div>
              <i class="el-icon-loading" v-if = "resultInfo[item.key].isLoading"></i>
              <div class="tab__content__body__item__result" v-else :class="resultInfo[item.key].result?'c_6': 'riskColor'" >
                {{  resultInfo[item.key].hint  }}
                <span v-if = "!resultInfo[item.key].result && !isLoading && resultInfo[item.key].hint" class="acc_link ml10" @click = "onJumpPage(item.path)">查看</span>
              </div>
            </div>
            <!-- 广告费和业务宣传费明细占比分析子项 -->
            <el-collapse-transition v-if = "Array.isArray(resultInfo[item.key].data)">
              <div class="tab__content__body__item__children" v-show ="resultInfo[item.key].isExpand">
                <div class="children__item__table">
                  <public-table :table="tableInfo[item.key]"></public-table>
                </div>
              </div>
            </el-collapse-transition>
          </div>

        </div>
      </div>
      <!-- 经营指标分析 -->
      <div class="tab__content" id="tab__content__4">
        <div class="tab__content__title">
          <div class="tab__content__title__pane"><img src="/static/img/physical_report/list_4.png" alt=""></div>
          <div class="tab__content__title__text">经营指标分析</div>
        </div>
        <div class="tab__content__body">
          <div class="tab__content__body__item" v-for = "item in operateIndex" :key="item.key" :ref = "item.key" :class="{ tab__content__body__tail: operateIndex.length - 1 === operateIndex.indexOf(item)}">
            <div class="tab__content__body__item__title">{{ item.name }}</div>
            <i class="el-icon-loading" v-if = "resultInfo[item.key].isLoading"></i>
            <div class="tab__content__body__item__result" v-else :class="resultInfo[item.key].result?'c_6': 'riskColor'" >
              {{  resultInfo[item.key].hint  }}
              <span v-if = "!resultInfo[item.key].result && !isLoading && resultInfo[item.key].hint" class="acc_link ml10" @click = "onJumpPage(item.path)">查看</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 重要节点提示 -->
      <div class="tab__content" id="tab__content__5">
        <div class="tab__content__title">
          <div class="tab__content__title__pane"><img src="/static/img/physical_report/list_5.png" alt=""></div>
          <div class="tab__content__title__text">重要节点提示</div>
        </div>
        <div class="tab__content__body">
          <!-- <div class="tab__content__body__nodata">
            <img src="/static/img/nodata.png" alt="">
          </div> -->
          <div class="tab__content__body__item" v-for = "item in importantNode" :key="item.key" :ref = "item.key" :class="{ tab__content__body__tail: importantNode.length - 1 === importantNode.indexOf(item)}">
            <div class="tab__content__body__item__title">
              <span>{{ item.name }}</span>
              <el-popover placement="right" width="350" trigger="hover" v-if = "item.tipText" :close-delay="0" transition="no-fade-in-linear">
                <div>{{ item.tipText }}</div>
                <i class="el-icon-warning-outline ml10" slot="reference"></i>
              </el-popover>
            </div>
            <i class="el-icon-loading" v-if = "resultInfo[item.key].isLoading"></i>
            <div class="tab__content__body__item__result" v-else :class="resultInfo[item.key].result?'c_6': 'riskColor'" >
              {{  resultInfo[item.key].hint  }}
              <span v-if = "!resultInfo[item.key].result && !isLoading && resultInfo[item.key].hint" class="acc_link ml10" @click = "onJumpPage(item.path)">查看</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import accountingPeriod from '@/components/dialog/accountingPeriod'
import publicTable from '@/components/publicTable'
import { debounce } from '@/assets/utils'
import { handleRiskCheck } from "@/api"
import {
  report_relationship_table,
  fixed_assets_table,
  fixed_depreciation_table,
  advertising_business_promotion_table,
  business_entertainment_expenses_table,
  welfare_expenses_operating_income_table,
  analysis_service_operating_revenue_table,
  travel_expenses_table
} from "./tableInfo"
import {accountIntegrity, taxIndex, financialIndex,operateIndex ,importantNode_s, importantNode_m} from "./dataBase"
export default {
  name: 'physical_report',
  components: {
    accountingPeriod, publicTable
  },
  data() {
    return {
      loadingText: 0,
      isMin: false, // 是否是小屏幕
      checkInfo: {
        score: 0,   // 得分
        riskNum: 0,   // 风险项数量
        checkTime: null, // 检测时间
      },
      // 检测结果值
      resultInfo: {
        bill_list:{},  // 票据清单
        voucher_number_interruption:{},  // 凭证断号
        fixed_assets_parent: {}, // 固定资产账卡核对
        fixed_assets: {}, // 资产原值不相符
        fixed_depreciation: {}, // 累计折旧不相符
        balance_sheet: {},  //  资产负债表平衡
        report_relationship: {},  // 报表勾稽关系
        bank_statements: {}, // 银行流水
        nil_return: {}, // 零申报
        profit_loss_year: {}, // 本年利润亏损
        excessive_inventory_balance: {}, // 库存余额过大
        // abnormal_tax_burden_rate: {}, // 税负率异常
        abnormal_monetary_funds: {}, // 货币资金异常
        cash_in_hand: {}, // 库存现金
        other_monetary_funds: {}, // 其他货币资金
        bank_deposits: {}, // 银行存款
        advertising_business_promotion: {}, // 广告费和业务宣传费明细占比分析
        business_entertainment_expenses: {}, // 业务招待费占营业收入比值分析
        welfare_expenses_operating_income: {}, // 福利费占营业收入比值分析
        analysis_service_operating_revenue: {}, // 服务费占营业收入比值分析
        travel_expenses: {}, // 差旅费
        matching_transportation_fixed_assets: {}, // 交通和固定资产匹配
        gross_margin: {}, // 毛利率
        asset_liability_ratio: {}, // 资产负债率
        profit_margin: {}, // 利润率
        income_consecutive_months: {}, // 小规模连续12个月收入是否超过500万元
        quarterly_sales_revenue: {}, // 小规模季度销售额是否超30万
        duty_employees: {}, // 在职职工超30人
        annual_taxable_income: {}, // 年度应纳税所得额不超过300万元
        total_assets: {}, // 资产总额不超过5000万元
      },
      isFinancialExpand: false,  // 是否展开所有财务指标
      // 循环数据--start
      accountIntegrity: accountIntegrity,  // 记账完整性
      taxIndex: taxIndex,  // 税务指标
      financialIndex: financialIndex,  // 财务指标
      operateIndex: operateIndex,  // 经营指标

      // 循环数据--end
      intervalTime: 0.08,  // 间隔时间  单位s
      isLoading: false,  // 是否加载中
      requestLoading: false,  // 是否请求中
      isOnceCheck: false,  // 是否曾经检测过
      physicalInfo: null,  // 体检信息
      yearPeriods: null,  // 会计期间
      tabPosition: "1",
      dotsInterval: null,  // 加载圆点定时器
      BeforeLoadingTimer: null,  // 加载前定时器
      // 列表数据--start
      tableInfo:{
        report_relationship: report_relationship_table,// 报表勾稽关系
        fixed_assets: fixed_assets_table, // 资产原值不相符
        fixed_depreciation: fixed_depreciation_table, // 累计折旧不相符
        advertising_business_promotion: advertising_business_promotion_table, // 广告费和业务宣传费明细占比分析
        business_entertainment_expenses: business_entertainment_expenses_table, // 业务招待费占营业收入比值分析
        welfare_expenses_operating_income: welfare_expenses_operating_income_table, // 福利费占营业收入比值分析
        analysis_service_operating_revenue: analysis_service_operating_revenue_table, // 服务费占营业收入比值分析
        travel_expenses: travel_expenses_table, // 差旅费
      },
      // 列表数据--end
      scrollInfo: {
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0,
        '5': 0,
      },
      _handleWrapperScroll: debounce(this.handleWrapperScroll, 50),
      _getViewListHeight: debounce(this.getViewListHeight, 50),
    }
  },
  created() {

  },
  mounted() {
    this._handleWrapperScroll = debounce(this.handleWrapperScroll, 300);
    this._getViewListHeight = debounce(this.getViewListHeight, 300);
    this.$nextTick(() => {
      let wrapperDom = document.getElementById("tab__content__wrapper_id");
      window.addEventListener("resize", this._getViewListHeight)
      wrapperDom.addEventListener('scroll', this._handleWrapperScroll)
      this.getViewListHeight();
    })
  },
  beforeDestroy() {
    let wrapperDom = document.getElementById("tab__content__wrapper_id");
    window.removeEventListener("resize", this._getViewListHeight)
    wrapperDom.removeEventListener("scroll", this._handleWrapperScroll)
  },
  computed: {
    importantNode() {
      let accountInfo = JSON.parse(sessionStorage.getItem("accountInfo"));
      if(accountInfo.scale=="2") {
        return importantNode_m
      }
      return importantNode_s
    },
    getBannerStyle() {
      let color = "#333333";
      let text = "财税检测"

      if((this.isOnceCheck && this.checkInfo.riskNum == 0) ||  this.isLoading) {
        color = "#269D7B";
        text = this.isLoading?"检测中<span id = 'dots'>...</span> ":"恭喜您！无风险项，财务数据良好！"
      }
      if(this.isOnceCheck && this.checkInfo.riskNum > 0 && !this.isLoading) {
        color = "#333333";
        text = `<span>存在 <span style='color: ${ this.checkInfo.score<60?'rgba(255, 96, 16, 1)':'#FF8500' };'>${ this.checkInfo.riskNum } </span>项风险</span>`
      }
      return {
        color,
        text,
      }
    }
  },
  methods: {
    // 点击展开【财务指标检测】所有子项
    handleFinancialExpandAll() {
      this.isFinancialExpand = !this.isFinancialExpand;
      for (let i=0;i<financialIndex.length;i++) {
        this.resultInfo[financialIndex[i].key].isExpand = this.isFinancialExpand;
      }
      setTimeout(()=> {
        this.getViewListHeight();
      },1000)
    },
    // 点击展开子项
    handleExpand(key) {
      this.resultInfo[key].isExpand = !this.resultInfo[key].isExpand;
      setTimeout(()=> {
        this.getViewListHeight();
      },1000)
    },
    // 点击查看跳转页面
    onJumpPage(path,query,item) {
      console.log(item,this.resultInfo[item.key],query);
      // 处理科目id
      if(item && this.resultInfo[item.key].remarks) {
        if(query && query.subjectId) {
          query.subjectId = this.resultInfo[item.key].remarks;
        }
      }
      let n_query = query?{ ...query,start: this.yearPeriods,end: this.yearPeriods }:{};
      this.$router.push({ path, query:n_query });
    },
    updateDots() {
      let dots = document.getElementById('dots').textContent;
      if (dots === '...') {
        dots = '.';
      } else {
        dots += '.';
      }
      document.getElementById('dots').textContent = dots;
    },
    // 查询当前账套的检测报告
    async onPhysicalReport(type) {
      // 检测中不能再检测
      if(this.isLoading) {
        return this.$message.warning("正在测试中，请稍后…");
      }
      this.clearCheckInfo();
      if(type == "2") {
        this.isLoading = true;
        this.dotsInterval = setInterval(this.updateDots, 500);
        // 第一项开始loading
        this.$set(this.resultInfo, "bill_list", { isLoading: true,name:"票据清单" })
      }else {
        this.isOnceCheck = false;
        this.requestLoading = true; // 请求loading
      }
      // 重置检测信息
      this.checkInfo = {
        checkTime: null,
        riskNum: 0, // 风险数量
        score: 0
      }
      this.loadingText = 0;
      let BeforeLoadingStep = 4
      this.BeforeLoadingTimer = setInterval(() => {
        if(this.loadingText <= 99) {
          if((this.loadingText + BeforeLoadingStep) > 99) {
              this.loadingText = 99
            }else {
              this.loadingText += BeforeLoadingStep
            }
        }
      }, this.intervalTime * 1000);
      const { data } = await handleRiskCheck({ type, yearPeriods: this.yearPeriods });
      clearInterval(this.BeforeLoadingTimer);
      if (data && data.data && data.data.indicatorsList) {
        let indicatorsList = data.data.indicatorsList
        this.checkInfo.checkTime = this.$util.formatDate.format(data.data.updateTime, 'yyyy-MM-dd hh:mm:ss');
        let fixed_assets_value = true;  // 固定资产账卡核对 是否相符
        let abnormal_monetary_value = true;  // 固定资产账卡核对 是否相符
        let totalNum = indicatorsList.length;
        let stepNum = Math.ceil(100 / totalNum);
        for (let i = 0; i < indicatorsList.length; i++) {
          let checkItem = indicatorsList[i];
          let checkItemKey = checkItem.keyStr;
          // 固定资产账卡核对 开始  插入他们的父辈key
          if ("fixed_assets" == checkItemKey) {
            this.$set(this.resultInfo, "fixed_assets_parent", { isLoading: true,name: "固定资产账卡核对"  })
          }
          // 货币资金异常 开始  插入他们的父辈key
          if ("cash_in_hand" == checkItemKey) {
            this.$set(this.resultInfo, "abnormal_monetary_funds", { isLoading: true,name: "货币资金异常"  })
          }
          // 项目loading开始
          this.$set(this.resultInfo, checkItemKey, { ...checkItem, isLoading: true,isExpand: false})

          if(this.loadingText <= 99) {
            if(type == "2") await this.handleInterval()
            if((this.loadingText + stepNum) > 100) {
              this.loadingText = 100
            }else {
              this.loadingText += stepNum
            }
          }else {
            this.loadingText = 100
          }
          this.resultInfo[checkItemKey]["isLoading"] = false;
          // 固定资产账卡核对 结束  插入他们的父辈key
          if (["fixed_assets","fixed_depreciation"].includes(checkItemKey)) {
            if(!checkItem.result && fixed_assets_value) {
              fixed_assets_value = false;
            }
            if(checkItemKey == "fixed_depreciation") {
              this.$set(this.resultInfo, "fixed_assets_parent", { ...checkItem,isLoading: false, hint: fixed_assets_value?"固定资产账卡相符":"固定资产账卡不相符",name: "固定资产账卡核对",result: fixed_assets_value})
              // 这里需要算进风险项
              if(!fixed_assets_value){ this.checkInfo.riskNum += 1};
            }
          }
           // 货币资金异常结束  插入他们的父辈key
           if (["cash_in_hand","excessive_cash_hand","bank_deposits"].includes(checkItemKey)) {
            if(!checkItem.result && abnormal_monetary_value) {
              abnormal_monetary_value = false;
            }
            if(checkItemKey == "bank_deposits") {
              this.$set(this.resultInfo, "abnormal_monetary_funds", { ...checkItem,isLoading: false, hint: abnormal_monetary_value?"正常":"异常",name: "货币资金异常",result: abnormal_monetary_value})
              // 这里需要算进风险项
              if(!fixed_assets_value){ this.checkInfo.riskNum += 1};
            }
          }
           // 特殊处理有表格的
           if(Array.isArray(checkItem.data)) {
              if(this.tableInfo[checkItemKey]) { this.tableInfo[checkItemKey].data = checkItem.data; }
            }
          // 计算分数,只有结果符合的时候才计算分数
          if (!checkItem.result) {
            this.checkInfo.riskNum += 1;
          }
        }
        this.checkInfo.score = Math.ceil(data.data.score);
        this.isOnceCheck = true;

      }else {
        this.$set(this.resultInfo, "bill_list", { isLoading: false,name:"票据清单" })
      }
      this.isLoading = false;
      this.requestLoading = false;
      clearInterval(this.dotsInterval);
    },
    // 根据ref获取元素并且滚动元素高度--暂时不用
    getRefHeight(refName) {
      this.$nextTick(()=> {
        const wrapperDom = document.getElementById("tab__content__wrapper_id");
        let dom = this.$refs[refName];
        if (dom && wrapperDom) {
          // 计算 dom 相对于 wrapperDom 的偏移量
          let rect = dom.getBoundingClientRect();
          let wrapperRect = wrapperDom.getBoundingClientRect();
          let scrollTop = rect.top - wrapperRect.top;
          wrapperDom.scrollTop = scrollTop;
        }
      })
    },
    // 间隔一定时间
    handleInterval() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, this.intervalTime * 1000)
      })
    },
    // 滚动监听
    handleWrapperScroll(e) {
      const scrollTop = e.target.scrollTop
      let nowKey = "1"
      for (let key in this.scrollInfo) {
        if ((scrollTop +80+174) >= this.scrollInfo[key]) {
          nowKey = key
        }
      }
      if (this.tabPosition != nowKey) {
        this.tabPosition = nowKey
      }
    },
    // tab切换
    handleTabChange(val) {
      let wrapperDom = document.getElementById("tab__content__wrapper_id");
      wrapperDom.scrollTop = this.scrollInfo[val];
    },
    // 动态获取显示内容高度
    getViewListHeight() {
      const wrapperDom = document.getElementById("tab__content__wrapper_id");
      for (let key in this.scrollInfo) {
        let dom = document.getElementById(`tab__content__${key}`);
        if (dom && wrapperDom) {
          // 计算 dom 相对于 wrapperDom 的偏移量
          let rect = dom.getBoundingClientRect();
          let wrapperRect = wrapperDom.getBoundingClientRect();
          // this.scrollInfo[key] = key=="1"?rect.top - wrapperRect.top + wrapperDom.scrollTop -90:rect.top - wrapperRect.top + wrapperDom.scrollTop -90;
          this.scrollInfo[key] = rect.top - wrapperRect.top + wrapperDom.scrollTop -90;
        } else {
          this.scrollInfo[key] = 0;
        }
      }
      // 格式化当前屏幕
      let  winW = window.innerWidth;
      if(winW >= 1500) {
        this.isMin = false;
      }else {
        this.isMin = true;
      }
    },
    // 接收会计期间数据
    defaultTime(data) {
      this.yearPeriods = this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM')
      this.onPhysicalReport('1');
    },
    // 清空检测值
    clearCheckInfo() {
      for(let key in this.resultInfo) {
        this.resultInfo[key] = {}
      }
    }
  }
}
</script>
<style lang="less" scoped>
.physical_report__wrapper {
  width: 1400px;
  margin: 0 auto 30px;
  box-sizing: border-box;
  height: calc(100% - 70px);
  overflow: auto;
  padding-top: 0 !important;
  .report__item__icon {
    display: flex;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    font-size: 14px;
    span {
      color: #269D7B;
    }

    img {
      width: 12px;
      height: 12px;
      margin-left: 7px;
    }

  }
  .report_tab {
    position: sticky;
    top: 0;
    background-color: #fff;
    padding: 20px 0;
    margin: 10px 0;
    z-index: 100;
  }
  .healthColor {
      color: #269D7B !important;
    }
    .riskColor {
      color: #FF6010 !important;
    }
    .middleColor {
      color: #FF8500 !important;
    }
  .tab__content__wrapper {
    // height: calc(100% - 300px);
    // overflow: auto;
  }

  .tab__content {
    &:not(:first-child) {
      margin-top: 30px;
    }

    &__body {
      padding: 0 24px;
      border: 1px solid rgba(231, 231, 231, 0.5);

      &__nodata {
        margin: 40px;
        text-align: center;

        img {
          width: 200px;
        }
      }

      &__tail {
        padding: 30px 0 !important;
        border-bottom: none !important;
      }

      &__item {
        padding: 30px 0 20px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px dashed #E6E6E6;
        .el-icon-loading {
          color: #269D7B;
        }
        &__title {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          display: flex;
          align-items: center;
          img {
            width: 18px;
            margin-right: 2px;
            cursor: pointer;
          }
        }

        &__result {
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }

        &__children {
          margin-left: 24px;
          .children__item__table {
            margin: 20px 0 0;
          }
          .children__item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
            &__title {
              display: flex;
              align-items: center;

              &__text {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                margin-right: 8px;
              }

              &__icon {
                display: flex;
                align-items: center;
                margin-left: 20px;
                cursor: pointer;
                font-size: 14px;
                span {
                  color: #269D7B;
                }

                img {
                  width: 12px;
                  height: 12px;
                  margin-left: 7px;
                }

              }
            }

            &__result {
              font-weight: 400;
              font-size: 14px;
              color: #666666;
            }
          }

        }
      }
    }

    &__title {
      padding: 20px 24px;
      display: flex;
      align-items: center;
      background: rgba(38, 157, 123, 0.05);
      border-radius: 4px 4px 0 0;
      .operation__title {
        flex: 1;
        &__wrapper {
          display: flex;
          align-items: center;
          justify-content: end;
          img {
            width: 16px;
            margin-left: 8px;
            transition: all .3s;
          }
        }
      }
      &__pane {
        // width: 5px;
        // height: 16px;
        // background: #269D7B;
        img {
          width: 26px;
          height: 26px;
        }
      }

      &__text {
        font-weight: 600;
        font-size: 16px;
        color: #666666;
        margin-left: 8px;
      }
    }
  }

  .score__view {
    padding: 36px 24px 36px 60px;
    height: 102px;
    background: url("/static/img/physical_report/banner.png");
    background-size: cover;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    &__left {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &__loading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
        color: #269D7B;
        font-weight: 600;
        &__text {
          display: flex;
          align-items: center;
        }
      }
      .left__circle__health {
        background: url("/static/img/physical_report/success.png");
        background-size: cover;
      }
      .left__circle__risk {
        background: url("/static/img/physical_report/fail.png");
        background-size: cover;
      }
      .left__circle__middle {
        background: url("/static/img/physical_report/fail.png");
        background-size: cover;
      }
      .left__circle__outside {
        width: 120px;
        height: 120px;
        border-radius: 50%;

        display: flex;
        align-items: center;
        justify-content: center;
        .left__circle__center {
          width: 114px;
          height: 114px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          // border: 1px dashed rgba(38, 157, 123, .1);
        }
        .left__circle__inside {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          &__score {
            font-weight: 600;
            font-size: 36px;
            color: #269D7B;
            display: flex;
            line-height: 30px;
            align-items: end;

            &__unit {
              font-size: 16px;
              line-height: 16px;
            }
          }
        }
      }

      &__center {
        margin-left: 28px;

        &__top {
          font-weight: 600;
          font-size: 32px;
          color: #269D7B;
        }

        &__bottom {
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }

    }

    &__right {
      display: flex;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/physical_report/physical_report.vue